import { useCallback, useEffect, useRef } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useFetchAnswerTypesByKind = (kind, { skip = false } = {}) => {
  const { apiGet } = useApi();
  const useApiState = createApiHook([]);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const apiGetRef = useRef(apiGet);
  const startLoadingRef = useRef(startLoading);
  const setResponseRef = useRef(setResponse);

  useEffect(() => {
    apiGetRef.current = apiGet;
  }, [apiGet]);

  useEffect(() => {
    startLoadingRef.current = startLoading;
  }, [startLoading]);

  useEffect(() => {
    setResponseRef.current = setResponse;
  }, [setResponse]);

  const fetchByKind = useCallback(
    async (k = kind) => {
      // Si no hay kind o es de tipo en "Contexto", se devuelve lista vacía para deshabilitar el Autocomplete
      if (skip || !k || k === "context") {
        setResponseRef.current({ data: [] });
        return [];
      }
      startLoadingRef.current();
      const response = await apiGetRef.current(
        `/answer_types/by_kind?kind=${encodeURIComponent(k)}`,
        "Error al obtener tipos de respuesta por tipo de pregunta",
      );
      setResponseRef.current(response);
      return response?.data || [];
    },
    [kind, skip],
  );

  useEffect(() => {
    fetchByKind(kind);
  }, [kind, fetchByKind]);

  return { data, error, loading, refetch: fetchByKind };
};

export default useFetchAnswerTypesByKind;
